module.exports = __webpack_public_path__ + "static/media/dept_structure.5919277f.png";